import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class Execute extends Component {
    constructor() {
        super();
        this.state = {
            menu: 'g-sidenav-show bg-gray-100',
            msg: ' Getting data from server....',
            vehicles: [],
            excuting: true,
            type: 'KM',
            st: "",
        }
    }
    async componentDidMount() {
        let baseurl = myconfig.getvehicles;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        await axios.post(baseurl, {
            "data1":sid,
            "data2":user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            }
            else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
            else {
                let msg = this.state.msg;
                msg = msg + "\n " + res.data.datas.length + " vehicles fetched from server."
                this.setState({
                    vehicles: res.data.datas,
                    msg: msg,
                    excuting:false,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    execute=async()=>{
        let baseurl = myconfig.executeecho;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        let msg = this.state.msg;
        msg = msg + "\n " + "Executing begin for the type "+this.state.type
        this.setState({
            excuting:true,
            msg:msg,
        })
        let count=this.state.vehicles.length;
        for(let i=0; i<count; i++) {
            msg = msg + "\n " + "Executing "+ (i+1) +" of "+ count
            msg = msg + "\n " + "Executing "+this.state.vehicles[i].plateno
            this.setState({
                excuting:true,
                msg:msg,
            })
            await axios.post(baseurl, {
                "data1": sid,
                "data2": user,
                "data3": this.state.st,
                "data4": this.state.vehicles[i].veh_id,
                "data5": this.state.type,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                    msg = msg + "\n " + "Session Expire";
                    this.setState({
                        excuting:true,
                        msg:msg,
                    })
                } else if (res.data.success == false) {
                    msg = msg + "\n " +res.data.msg;
                    this.setState({
                        excuting:true,
                        msg:msg,
                    })
                } else {
                    msg = msg + "\n " + res.data.msg;
                    this.setState({
                        excuting:true,
                        msg:msg,
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        this.setState({
            excuting:false,
        })
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    btnexecute = (event) => {
        event.preventDefault();
        if (!this.state.excuting) {
            if (this.state.type == "") {
                Swal.fire({
                    title: 'Error!',
                    text: "Select type",
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
            else if (this.state.st == "") {
                Swal.fire({
                    title: 'Error!',
                    text: "Enter date",
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
            else {
                this.execute();
            }
        }
    }
    menuhidden=(event)=>{
        event.preventDefault();
        if(this.state.menu=="g-sidenav-show bg-gray-100")
            this.setState({
                menu:"g-sidenav-show bg-gray-100 g-sidenav-pinned"
            })
        else
            this.setState({
                menu:"g-sidenav-show bg-gray-100"
            })
    }
    table=()=> {
        let count=0
        let tabledata=this.state.movingdatas.map(value => {
            count=count+1;
            return(
                <tr>
                    <td>
                        <h6 className="mb-0 text-xs">{value.loc}</h6>
                    </td>
                    <td>
                        <p className="text-xs font-weight-bold mb-0">{value.count}</p>
                    </td>
                    <td>
                        <a href="" onClick={(event => this.movingdet(event,value.loc))}>
                            <i className="fas fa-eye text-secondary" aria-hidden="true"></i>
                        </a>
                    </td>
                </tr>
            )
        })
        return (<table className="table align-items-center mb-0">
            <thead>
            <tr>
                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7">Heading To</th>
                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Vehicles</th>
                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2"></th>
            </tr>
            </thead>
            <tbody>
            {tabledata}
            </tbody>
        </table>)
    }
    render() {
        return (
            <>
                <div className="min-height-300 bg-primary position-absolute w-100"></div>
                <div className={this.state.menu}>
                    <Nav type="home"/>
                    <main className="main-content position-relative border-radius-lg ">
                        {/* Navbar */}
                        <nav className="navbar navbar-main navbar-expand-lg  px-0 mx-4 shadow-none border-radius-xl z-index-sticky " id="navbarBlur" data-scroll="false">
                            <div className="container-fluid py-1 px-3">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
                                        <li className="breadcrumb-item text-sm">
                                            <a className="text-white" href="#">
                                                <i className="ni ni-box-2" />
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item text-sm text-white"><a className="opacity-5 text-white" href="#">Dashboard</a></li>
                                    </ol>
                                    <h6 className="font-weight-bolder mb-0 text-white">Heading</h6>
                                </nav>
                                <div className="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                                    <a href="#" onClick={this.menuhidden} className="nav-link p-0">
                                        <div className="sidenav-toggler-inner">
                                            <i className="sidenav-toggler-line bg-white" />
                                            <i className="sidenav-toggler-line bg-white" />
                                            <i className="sidenav-toggler-line bg-white" />
                                        </div>
                                    </a>
                                </div>
                                <div className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
                                    <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                                        <div className="input-group">
                                            <span className="input-group-text text-body"><i className="fas fa-search" aria-hidden="true" /></span>
                                            <input type="text" className="form-control" placeholder="Type here..." />
                                        </div>
                                    </div>
                                    <ul className="navbar-nav  justify-content-end">
                                        <li className="nav-item d-flex align-items-center">
                                            <a href="" className="nav-link text-white font-weight-bold px-0">
                                                <i className="fa fa-user me-sm-1" />
                                                <span className="d-sm-inline d-none">ncapi</span>
                                            </a>
                                        </li>
                                        <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
                                            <a href="#" className="nav-link text-white p-0" onClick={this.menuhidden}>
                                                <div className="sidenav-toggler-inner">
                                                    <i className="sidenav-toggler-line bg-white" />
                                                    <i className="sidenav-toggler-line bg-white" />
                                                    <i className="sidenav-toggler-line bg-white" />
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                        {/* End Navbar */}
                        <div className="container-fluid py-4">
                            <div className="row mt-4">
                                <div className="col-lg-8 mx-auto mt-lg-0 mt-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <h5 className="font-weight-bolder">Echo Report Executor</h5>
                                            <div className="row">
                                                <div className="col-12 col-sm-6">
                                                    <label>Report Name</label>
                                                    <select name="type" value={this.state.type} onChange={this.inputmgt} className="form-control">
                                                        <option value="KM">KM</option>
                                                        <option value="SPEED">SPEED</option>
                                                        <option value="IDEL">IDEL</option>
                                                        <option value="VIO">VIO</option>
                                                    </select>
                                                </div>
                                                <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                    <label>Date</label>
                                                    <input name="st" value={this.state.st} onChange={this.inputmgt}
                                                        className="form-control" type="date" defaultValue={2}
                                                           onFocus="focused(this)" onfocusout="defocused(this)"/>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <button onClick={this.btnexecute} className="btn btn-primary btn-block mt-3">Execute Data</button>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <label className="mt-4">Message</label>
                                                    <textarea rows={10} className="form-control" value={this.state.msg}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>

            </>
        )
    }
}

export default Execute;
